// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__P8xTg","text_wrapper":"styles_text_wrapper__QW5NK","description":"styles_description__VjC-S","actions":"styles_actions__ts+5C"};